import { keyframes, css } from 'styled-components';

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const popIn = keyframes`
  from { transform: scale(0.7); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
`;

const animVeryDissatisfied = keyframes`
  0%   { transform: translateX(0) rotate(0deg); }
  15%  { transform: translateX(-7px) rotate(-4deg); }
  30%  { transform: translateX(7px)  rotate(4deg); }
  45%  { transform: translateX(-5px) rotate(-2deg); }
  60%  { transform: translateX(5px)  rotate(2deg); }
  75%  { transform: translateX(-3px); }
  100% { transform: translateX(0) rotate(0deg); }
`;

const animDissatisfied = keyframes`
  0%   { transform: translateY(0) scale(1); }
  35%  { transform: translateY(5px) scale(0.93); }
  65%  { transform: translateY(3px) scale(0.96); }
  100% { transform: translateY(0) scale(1); }
`;

const animSatisfied = keyframes`
  0%   { transform: translateY(0) scale(1); }
  30%  { transform: translateY(-9px) scale(1.1); }
  55%  { transform: translateY(-3px) scale(1.04); }
  75%  { transform: translateY(-6px) scale(1.07); }
  100% { transform: translateY(0) scale(1); }
`;

const animVerySatisfied = keyframes`
  0%   { transform: scale(1)    rotate(0deg); }
  20%  { transform: scale(1.28) rotate(-10deg); }
  45%  { transform: scale(1.18) rotate(10deg); }
  65%  { transform: scale(1.22) rotate(-5deg); }
  82%  { transform: scale(1.06) rotate(3deg); }
  100% { transform: scale(1)    rotate(0deg); }
`;

export const FACE_ANIMATIONS = {
  very_dissatisfied: css`
    animation: ${animVeryDissatisfied} 500ms ease-in-out;
  `,
  dissatisfied: css`
    animation: ${animDissatisfied} 600ms ease-out;
  `,
  satisfied: css`
    animation: ${animSatisfied} 500ms ease-out;
  `,
  very_satisfied: css`
    animation: ${animVerySatisfied} 600ms ease-out;
  `,
};
